import { Text } from '@thanx/uikit/text'
import { buildTranslate } from 'locales'
import React from 'react'
import Body3Html from './common/Body3Html'
import LegalContainer from './common/LegalContainer'
import List from './common/List'
import {
  asRecoveryAiTermsItems,
  RECOVERY_AI_TERMS_SECTIONS,
} from './recoveryAiTermsSections'

const t = buildTranslate('legal.recovery_ai_terms')

function RecoveryAiTerms() {
  return (
    <LegalContainer>
      <Text.Header2>{t('title')}</Text.Header2>

      <Body3Html tag="p">{t('intro')}</Body3Html>
      <Body3Html tag="p">{t('attestation')}</Body3Html>
      <Body3Html tag="p">{t('incorporation')}</Body3Html>

      {RECOVERY_AI_TERMS_SECTIONS.map(({ key, kind }, i) => {
        const num = i + 1
        const prefix = `${num}.`
        return (
          <React.Fragment key={key}>
            <Text.Header3>
              {prefix} {t(`${key}.title`)}
            </Text.Header3>
            {kind === 'prose' ? (
              <Body3Html tag="p">{t(`${key}.content`)}</Body3Html>
            ) : (
              <List
                prefix={prefix}
                items={asRecoveryAiTermsItems(t(`${key}.items`))}
              />
            )}
          </React.Fragment>
        )
      })}
    </LegalContainer>
  )
}

export default RecoveryAiTerms
